export interface ShellRailDescriptor {
  id: string;
  side: "left" | "right";
  isVisible: boolean;
  width: string;
  behavior?: "push" | "overlay";
}

export interface ShellRailGeometry {
  activeLeftRailIds: string[];
  activeRightRailIds: string[];
  leftWidth: string;
  rightWidth: string;
  mainSurfaceRadiusClass: string;
  cssVars: Record<string, string>;
}

export const MAIN_CONTENT_ROUNDED_CLASS =
  "rounded-tl-2xl rounded-bl-2xl rounded-tr-2xl rounded-br-2xl";

export function resolveShellRailGeometry(
  rails: readonly ShellRailDescriptor[],
): ShellRailGeometry {
  const pushRails = rails.filter(
    (rail) => rail.isVisible && (rail.behavior ?? "push") === "push",
  );
  const leftRails = pushRails.filter((rail) => rail.side === "left");
  const rightRails = pushRails.filter((rail) => rail.side === "right");
  const leftWidth = sumWidthTokens(leftRails.map((rail) => rail.width));
  const rightWidth = sumWidthTokens(rightRails.map((rail) => rail.width));

  return {
    activeLeftRailIds: leftRails.map((rail) => rail.id),
    activeRightRailIds: rightRails.map((rail) => rail.id),
    leftWidth,
    rightWidth,
    mainSurfaceRadiusClass: MAIN_CONTENT_ROUNDED_CLASS,
    cssVars: {
      "--fintheon-shell-left-rail-width": leftWidth,
      "--fintheon-shell-right-rail-width": rightWidth,
      "--fintheon-shell-main-radius": "1rem",
    },
  };
}

function sumWidthTokens(widths: string[]): string {
  const tokens = widths.map((width) => width.trim()).filter(Boolean);
  if (tokens.length === 0) return "0px";
  if (tokens.length === 1) return tokens[0];
  return `calc(${tokens.join(" + ")})`;
}
